import React from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker
} from "@material-ui/pickers";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";

const DateFilterStart = props => {
  const { dateStart, handleDateStartChange } = props;

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">
        <KeyboardDatePicker
          disableToolbar
          variant="inline"
          format="MM/dd/yyyy"
          margin="normal"
          id="date-picker-inline"
          label="Fecha de inicio"
          value={dateStart}
          onChange={handleDateStartChange}
          KeyboardButtonProps={{
            "aria-label": "change date"
          }}
        />
      </Grid>
    </MuiPickersUtilsProvider>
  );
};

export default DateFilterStart;

DateFilterStart.propTypes = {
  dateStart: PropTypes.object,
  handleDateStartChange: PropTypes.func
};
